<template>
  <b-form @submit="onSubmit">
    <b-form-group
        id="formgroup-name"
        :label="$t('trigger.form.fields.nome.label')"
        :description="$t('trigger.form.fields.nome.description')"
        label-for="trigger-name"
        required
    >
      <b-form-input id="trigger-name" v-model="name" trim/>
    </b-form-group>

    <Condition
        v-for="(condition, index) in form.conditions"
        :form="condition"
        :key="index"
        :showDescription="condition.showDescription"
        @change="populateConditions"
    />
    <div>
      <button class="btn btn-sm btn-outline-success"
              @click="conditions = [
                    ...conditions,
                    {
                    showDescription: false,
                    index: conditions.length
                    }
                ]"
              type="button"
      >
        <i class="fa fa-plus"></i>
        {{ $t('trigger.form.buttons.adicionar_condicao') }}
      </button>
      <button v-if="conditions.length > 1"
              class="btn btn-sm btn-outline-danger"
              @click="conditions.length > 1 ? conditions.pop() : ''"
              type="button"
      >
        <i class="fa fa-minus-circle"></i>
        {{ $t('trigger.form.buttons.remover_condicao') }}
      </button>
    </div>
    <b-form-group
        id="formgroup-action"
        label-for="trigger-action"
        :label="$t('trigger.form.fields.action.label')"
        :description="$t('trigger.form.fields.action.description')"
        @change="(v) => setTrigger('trigger_action', {id: v})"
        required
    >
      <b-form-select v-model="form.action" :options="actions"/>
    </b-form-group>
    <b-button type="submit" variant="success">
      <i class="fas fa-save"/> {{ $t('trigger.form.buttons.salvar') }}
    </b-button>
  </b-form>
</template>

<script>
import LayoutDefault from '@/templates/LayoutDefault'
import Condition from '@/pages/triggers/components/Condition'
import TriggerRepository from "@/repositories/triggers/TriggerRepository";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "TriggerForm",
  components: {
    LayoutDefault,
    Condition
  },
  props: {
    id: {
      String,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      trigger: 'trigger/current',
      actionsBackend: 'trigger/actions'
    }),
    form() {
      return {
        name: this.name,
        conditions: this.conditions,
        action: this.trigger && this.trigger.trigger_action ? this.trigger.trigger_action.id : null,
        id: this.trigger ? this.trigger.id : null
      }
    },
    actions() {
      return this.actionsBackend.map((action) => {
        return {value: action.id, text: this.$t('trigger.form.fields.action.options.' + action.name)}
      })
    }
  },
  data() {
    return {
      name: '',
      conditions: []
    }
  },
  methods: {
    ...mapActions([
      'trigger/find',
      'trigger/listAllActions'
    ]),
    convertConditionsToString() {
      let conditionString = ''
      this.form.conditions.forEach((element) => {

        // Adiciona a && caso string não esteja vazia
        if (conditionString !== '') {
          conditionString += ' && '
        }

        conditionString += element.firstField + ' ' + element.regra

        if (element.regra === 'IS NULL') {
          conditionString += ' OR ' + element.firstField + ' = ""'
          return
        }
        if (element.regra === 'IS NOT NULL') {
          conditionString += ' OR ' + element.firstField + ' != ""'
          return
        }
        if (element.regra === 'BETWEEN') {
          conditionString += ' ' + element.secondField + ' AND ' + element.thirdField
          return
        }
        if (element.regra === 'NOT BETWEEN') {
          conditionString += ' ' + element.secondField + ' AND ' + element.thirdField
          return
        }

        conditionString += ' ' + element.secondField
      })
      return conditionString
    },
    convertStringToConditions() {
      let arrayConditions = this.trigger.rule.split(' && ')
      arrayConditions.forEach((element, index) => {
        switch (true) {
          case element.includes('IS NULL'):
            const isNull = element.split(' IS NULL')
            arrayConditions[index] = {
              index,
              firstField: isNull[0],
              regra: 'IS NULL',
              secondField: null,
              thirdField: null,
            }
            break;
          case element.includes('IS NOT NULL'):
            const isNotNull = element.split(' IS NOT NULL')
            arrayConditions[index] = {
              index,
              firstField: isNotNull[0],
              regra: 'IS NOT NULL',
              secondField: null,
              thirdField: null,
            }
            break;
          case element.includes('NOT BETWEEN'):
            const notBtween = element.split(' NOT BETWEEN ')
            arrayConditions[index] = {
              index,
              firstField: notBtween[0],
              regra: 'NOT BETWEEN',
              secondField: notBtween[1].split(' AND ')[0],
              thirdField: notBtween[1].split(' AND ')[1],
            }
            break;
          case element.includes('BETWEEN'):
            const btween = element.split(' BETWEEN ')
            arrayConditions[index] = {
              index,
              firstField: btween[0],
              regra: 'BETWEEN',
              secondField: btween[1].split(' AND ')[0],
              thirdField: btween[1].split(' AND ')[1],
            }
            break;
          case element.includes('>='):
            arrayConditions[index] = {
              index,
              firstField: element.split(' >= ')[0],
              regra: '>=',
              secondField: element.split(' >= ')[1],
              thirdField: null,
            }
            break;
          case element.includes('>'):
            arrayConditions[index] = {
              index,
              firstField: element.split(' > ')[0],
              regra: '>',
              secondField: element.split(' > ')[1],
              thirdField: null,
            }
            break;
          case element.includes('<='):
            arrayConditions[index] = {
              index,
              firstField: element.split(' <= ')[0],
              regra: '<=',
              secondField: element.split(' <= ')[1],
              thirdField: null,
            }
            break;
          case element.includes('<'):
            arrayConditions[index] = {
              index,
              firstField: element.split(' < ')[0],
              regra: '<',
              secondField: element.split(' < ')[1],
              thirdField: null,
            }
            break;
          case element.includes('=='):
            arrayConditions[index] = {
              index,
              firstField: element.split(' == ')[0],
              regra: '==',
              secondField: element.split(' == ')[1],
              thirdField: null,
            }
            break;
          case element.includes('!='):
            arrayConditions[index] = {
              index,
              firstField: element.split(' != ')[0],
              regra: '!=',
              secondField: element.split(' != ')[1],
              thirdField: null,
            }
            break;
        }
      })
      this.conditions = arrayConditions
    },
    async create() {
      // Gera String para inserir no banco
      const rules = this.convertConditionsToString()
      await TriggerRepository.post({
        name: this.form.name,
        rule: rules,
        vam_trigger_actions_id: this.form.action,
        status: 1
      }).then(() => {
        this.$snotify.success(this.$t('trigger.form.create.success'))
        this.$router.push({name: 'trigger.index'})
      }).catch(error => {
        this.$snotify.error(this.$t('trigger.form.create.error'))
        if (error.response.status === 422) {
          TriggerRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    },
    populateConditions(condition) {
      this.form.conditions.forEach((element, idx) => {
        if (element.index === condition.index) {
          this.form.conditions[idx] = condition
        }
      });
    },
    async update() {
      // Gera String para inserir no banco
      const rules = this.convertConditionsToString()
      const obj = {
        id: this.form.id,
        name: this.form.name,
        rule: rules,
        vam_trigger_actions_id: this.form.action,
        status: 1
      }
      await TriggerRepository.put(this.form.id, obj).then(response => {
        if (response.data.data) {
          this.$snotify.success(this.$t('trigger.form.update.success'))
          this.$emit('updated', obj)
          return
        }
        this.$snotify.error(this.$t('trigger.form.update.success'))
      }).catch(error => {
        this.$snotify.error(this.$t('trigger.form.update.error'))
        if (error.response.status === 422) {
          TriggerRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    },
    onSubmit(evt) {
      evt.preventDefault()
      if (this.id) {
        this.update()
      } else {
        this.create()
      }
    },
    setTrigger(key, value) {
      this.$store.commit('vns/setCurrent', {...this.vns, [key]: value})
    },

  },
  async mounted() {
    await this['trigger/listAllActions']()
    if (this.id) {
      await this['trigger/find'](this.id)
      this.convertStringToConditions()
      this.name = this.trigger.name
      return
    }
    this.form.conditions = [{index: 0}]
  }
}
</script>

<style scoped>
.btn-outline-success,
.btn-outline-danger {
  border-color: transparent;
}
</style>
